export const getRetValue = (val: number, accending: any) => {
  if (val < 0) {
    return accending ? 1 : -1;
  } else if (val > 0) {
    return accending ? -1 : 1;
  }
  return 0;
};

const getNullRet = (a: any, b: any, accending: any) => {
  if (!a && !b) {
    return 0;
  } else if (!a) {
    return getRetValue(1, accending);
  } else if (!b) {
    return getRetValue(-1, accending);
  }

  return 0;
};

export const getOrder = (aa: any, bb: any, accending: any): number => {
  if (aa && bb) {
    return aa == bb
      ? 0
      : aa > bb
      ? getRetValue(-1, accending)
      : getRetValue(1, accending);
  }
  return getNullRet(aa, bb, accending);
};
